"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var isProduction = function isProduction() {
  //In Node (used during server-side rendering), checking against an undefined variable throws an error.
  var environment = typeof window !== "undefined" && window && window.__shellInternal && window.__shellInternal.environment; //QBO and IEP use "prod".

  return environment === "production" || environment === "prod";
};

var alreadyLoggedDeprecationWarnings = new Set();
var logger = {
  error: function error() {
    var _console;

    return (_console = console).error.apply(_console, arguments);
  },
  log: function log() {
    var _console2;

    return !isProduction() && (_console2 = console).log.apply(_console2, arguments);
  },
  warn: function warn() {
    var _console3;

    return (_console3 = console).warn.apply(_console3, arguments);
  },
  deprecationWarning: function deprecationWarning(message) {
    if (isProduction()) {
      return;
    }

    if (alreadyLoggedDeprecationWarnings.has(message)) {
      return;
    }

    console.warn(message);
    alreadyLoggedDeprecationWarnings.add(message);
  }
};
var _default = logger;
exports["default"] = _default;